import React, { ReactNode } from 'react'
import './vsplit.css';

interface Props {
    children : ReactNode;
    classes? : string;

}

export class VSplit extends React.Component<Props> {

    getClasses() : string
    {
        if (this.props.classes === undefined) {
            return "vsplit";
        }
        else {
            return "vsplit " + this.props.classes;
        }
    }

    render() {
        return (
            <div className={ this.getClasses() }>
                { this.props.children }
            </div>
        );
    }
}

